export default __webpack_public_path__ + "static/media/bankSlipModal.872d21db.png";